import React from 'react'
import NavLink from '../../components/Routes/NavLink'

import WorkOrdersList from '../../components/WorkOrders/WorkOrdersList.jsx'
import CardHolder from '../../helpers/Cards/CardHolder';
import { workOrders } from '../../core/controllers/WorkOrders';
import {WorkOrdersCompleted, WorkOrdersActiveRequest, WorkOrdersPriorityRequest, WorkOrderNewRequests } from '../../helpers/Cards/Cards';

export default class MaintenanceTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orderFilter : 'All',
            filter: props.filter.filter,
            workOrders: {},
        };

        if (this.state.filter != null) {
            if (this.state.filter == "priority") {
                this.state.orderFilter = 'High,Emergency';
            } else {
                this.state.orderFilter = 'LastSevenDays'
            }
        }
    }

    componentDidMount() {
        var self = this;
        workOrders.getWorkOrders(this.state.orderFilter, null, function(response){
            if(response.data.length > 0) {
                self.setState({
                    workOrders: response.data
                });
            }
        });
    }

    updateFilter(type) {
        var orderFilter = 'All';
        if (this.state.filter == type) {
            type = null;
        } else {
            if (type != null) {
                if (type == "priority") {
                    orderFilter = 'High,Emergency';
                } else if (type == "LastSevenDays") {
                    orderFilter = 'LastSevenDays'
                }
            }
        }

        this.setState({
            filter: type,
            orderFilter: orderFilter
        });
    }

    render(){
        const workOrders = this.state.workOrders;
        var priority = '';
        var recentlyAdded = '';
        var selected = this.state.filter;
        if (selected != null) {
            if (selected == 'priority') {
                priority = 'checked';
            } else if (selected == 'LastSevenDays') {
                recentlyAdded = 'checked';
            }
        }
        return (
            <div>
                {workOrders.length > 0 ? (
                <div>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <span class="main-page-header-title">Maintenance</span>
                            </div>
                            <div class="maint-request-btn col-md-2 col-md-offset-7 col-sm-12 col-xs-12">
                                <NavLink to={"/maintenance/order/new"}>
                                    <button type="button" id="add-work-order" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">Submit Request</button>
                                    <div class="clearfix"></div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <CardHolder width="100%" columnCount={4} paddingWidth={15}>
                                <WorkOrderNewRequests clickable={true} />
                                <WorkOrdersPriorityRequest clickable={true} />
                                <WorkOrdersActiveRequest clickable={true} />
                                <WorkOrdersCompleted followUp={"follow_up"} clickable={true} />
                            </CardHolder>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-title card">
                                <div class="header col-md-4 col-sm-12 col-xs-12">
                                    <h4 class="title">Maintenance Requests</h4>
                                    <p class="category">Complete list of all maintenance requests</p>
                                </div>
                                <div class="filter-options col-md-8 col-sm-12 col-xs-12">
                                    <label class="filter-checkbox-container">Recently Added
                                        <input type="checkbox" class="filter-checkbox" checked={recentlyAdded} onClick={this.updateFilter.bind(this, 'LastSevenDays')}/>
                                    </label>
                                    <label class="filter-checkbox-container">Priority
                                        <input type="checkbox" class="filter-checkbox" checked={priority} onClick={this.updateFilter.bind(this, 'priority')}/>
                                    </label>
                                    {/* { selected != null && (
                                        <span class="clickable-action" onClick={this.updateFilter.bind(this, null)}>reset table</span>
                                    )} */}
                                </div>
                                <div class="content">
                                    <WorkOrdersList orderFilter={this.state.orderFilter}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : (
                    <div>
                        <div style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div class="row">
                                        <span class="main-page-header-title">No Maintenance Requests Yet</span>
                                    </div>
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/maintenance/order/new"}>
                                            <button type="button" id="add-work-order" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">Submit Request</button>
                                            <div class="clearfix"></div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/maintenance.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '560px'}}></div>
                    </div>
                )}
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Maintenance/Maintenance.jsx